import { useNavigate } from "react-router-dom";
import ProductPageShell from "@/components/ProductPageShell";
import { Clock } from "lucide-react";

export default function Sprint() {
  const navigate = useNavigate();

  const visual = (
    <div className="relative aspect-square max-w-sm mx-auto w-full">
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-emerald-500/15 via-[#0F1D40] to-[#14264F] border border-emerald-500/20 overflow-hidden flex items-center justify-center">
        <div className="relative">
          <div className="absolute -inset-10 rounded-full bg-emerald-500/10 blur-3xl" />
          <div className="relative w-32 h-32 rounded-full border-2 border-emerald-500/30 bg-[#0B1735] flex items-center justify-center">
            <div className="text-center">
              <Clock className="w-7 h-7 text-emerald-400 mx-auto mb-1" />
              <div className="text-2xl font-extrabold text-white">3h</div>
              <div className="text-[10px] font-mono text-emerald-400 tracking-widest">DIAGNOSTIC</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <ProductPageShell
      product="sprint"
      label="Operon Sprint"
      accent="emerald"
      kicker="Operon Sprint · For founders who want clarity fast"
      title="Three hours. Three answers."
      lede="A short, intense diagnostic engagement for therapeutic-startup teams. We cut through the noise and send you home with three things: what's going well, what's wrong, and what to do next."
      bullets={[
        { title: "What's going well", body: "An honest external read on the parts of your strategy that already hold up — so you keep investing in them." },
        { title: "What's wrong", body: "The quiet gaps, the overlooked risks and the inconsistencies the data room keeps hiding — named, explained and ranked." },
        { title: "Priority actions", body: "A short list of the highest-leverage moves for the next 90 days, with the rationale for each." },
      ]}
      visual={visual}
      secondaryCta={{ label: "Open Studio", onClick: () => navigate("/sprint/studio") }}
    />
  );
}
